export const COUNTRY_CODE_OPTIONS = [
  { value: "IDN", label: "IDN - Indonesia" },
  { value: "AFG", label: "AFG - Afghanistan" },
  { value: "ALA", label: "ALA - Åland Islands" },
  { value: "ALB", label: "ALB - Albania" },
  { value: "DZA", label: "DZA - Algeria" },
  { value: "ASM", label: "ASM - American Samoa" },
  { value: "AND", label: "AND - Andorra" },
  { value: "AGO", label: "AGO - Angola" },
  { value: "AIA", label: "AIA - Anguilla" },
  { value: "ATA", label: "ATA - Antarctica" },
  { value: "ATG", label: "ATG - Antigua and Barbuda" },
  { value: "ARG", label: "ARG - Argentina" },
  { value: "ARM", label: "ARM - Armenia" },
  { value: "ABW", label: "ABW - Aruba" },
  { value: "AUS", label: "AUS - Australia" },
  { value: "AUT", label: "AUT - Austria" },
  { value: "AZE", label: "AZE - Azerbaijan" },
  { value: "BHS", label: "BHS - Bahamas" },
  { value: "BHR", label: "BHR - Bahrain" },
  { value: "BGD", label: "BGD - Bangladesh" },
  { value: "BRB", label: "BRB - Barbados" },
  { value: "BLR", label: "BLR - Belarus" },
  { value: "BEL", label: "BEL - Belgium" },
  { value: "BLZ", label: "BLZ - Belize" },
  { value: "BEN", label: "BEN - Benin" },
  { value: "BMU", label: "BMU - Bermuda" },
  { value: "BTN", label: "BTN - Bhutan" },
  { value: "BOL", label: "BOL - Bolivia" },
  { value: "BES", label: "BES - Bonaire, Sint Eustatius and Saba" },
  { value: "BIH", label: "BIH - Bosnia and Herzegovina" },
  { value: "BWA", label: "BWA - Botswana" },
  { value: "BVT", label: "BVT - Bouvet Island" },
  { value: "BRA", label: "BRA - Brazil" },
  { value: "IOT", label: "IOT - British Indian Ocean Territory" },
  { value: "BRN", label: "BRN - Brunei Darussalam" },
  { value: "BGR", label: "BGR - Bulgaria" },
  { value: "BFA", label: "BFA - Burkina Faso" },
  { value: "BDI", label: "BDI - Burundi" },
  { value: "CPV", label: "CPV - Cabo Verde" },
  { value: "KHM", label: "KHM - Cambodia" },
  { value: "CMR", label: "CMR - Cameroon" },
  { value: "CAN", label: "CAN - Canada" },
  { value: "CYM", label: "CYM - Cayman Islands" },
  { value: "CAF", label: "CAF - Central African Republic" },
  { value: "TCD", label: "TCD - Chad" },
  { value: "CHL", label: "CHL - Chile" },
  { value: "CHN", label: "CHN - China" },
  { value: "CXR", label: "CXR - Christmas Island" },
  { value: "CCK", label: "CCK - Cocos (Keeling) Islands" },
  { value: "COL", label: "COL - Colombia" },
  { value: "COM", label: "COM - Comoros" },
  { value: "COG", label: "COG - Congo" },
  { value: "COD", label: "COD - Congo (Democratic Republic)" },
  { value: "COK", label: "COK - Cook Islands" },
  { value: "CRI", label: "CRI - Costa Rica" },
  { value: "CIV", label: "CIV - Côte d'Ivoire" },
  { value: "HRV", label: "HRV - Croatia" },
  { value: "CUB", label: "CUB - Cuba" },
  { value: "CUW", label: "CUW - Curaçao" },
  { value: "CYP", label: "CYP - Cyprus" },
  { value: "CZE", label: "CZE - Czechia" },
  { value: "DNK", label: "DNK - Denmark" },
  { value: "DJI", label: "DJI - Djibouti" },
  { value: "DMA", label: "DMA - Dominica" },
  { value: "DOM", label: "DOM - Dominican Republic" },
  { value: "ECU", label: "ECU - Ecuador" },
  { value: "EGY", label: "EGY - Egypt" },
  { value: "SLV", label: "SLV - El Salvador" },
  { value: "GNQ", label: "GNQ - Equatorial Guinea" },
  { value: "ERI", label: "ERI - Eritrea" },
  { value: "EST", label: "EST - Estonia" },
  { value: "SWZ", label: "SWZ - Eswatini" },
  { value: "ETH", label: "ETH - Ethiopia" },
  { value: "FLK", label: "FLK - Falkland Islands" },
  { value: "FRO", label: "FRO - Faroe Islands" },
  { value: "FJI", label: "FJI - Fiji" },
  { value: "FIN", label: "FIN - Finland" },
  { value: "FRA", label: "FRA - France" },
  { value: "GUF", label: "GUF - French Guiana" },
  { value: "PYF", label: "PYF - French Polynesia" },
  { value: "ATF", label: "ATF - French Southern Territories" },
  { value: "GAB", label: "GAB - Gabon" },
  { value: "GMB", label: "GMB - Gambia" },
  { value: "GEO", label: "GEO - Georgia" },
  { value: "DEU", label: "DEU - Germany" },
  { value: "GHA", label: "GHA - Ghana" },
  { value: "GIB", label: "GIB - Gibraltar" },
  { value: "GRC", label: "GRC - Greece" },
  { value: "GRL", label: "GRL - Greenland" },
  { value: "GRD", label: "GRD - Grenada" },
  { value: "GLP", label: "GLP - Guadeloupe" },
  { value: "GUM", label: "GUM - Guam" },
  { value: "GTM", label: "GTM - Guatemala" },
  { value: "GGY", label: "GGY - Guernsey" },
  { value: "GIN", label: "GIN - Guinea" },
  { value: "GNB", label: "GNB - Guinea-Bissau" },
  { value: "GUY", label: "GUY - Guyana" },
  { value: "HTI", label: "HTI - Haiti" },
  { value: "HMD", label: "HMD - Heard Island and McDonald Islands" },
  { value: "VAT", label: "VAT - Holy See" },
  { value: "HND", label: "HND - Honduras" },
  { value: "HKG", label: "HKG - Hong Kong" },
  { value: "HUN", label: "HUN - Hungary" },
  { value: "ISL", label: "ISL - Iceland" },
  { value: "IND", label: "IND - India" },
  { value: "IRN", label: "IRN - Iran" },
  { value: "IRQ", label: "IRQ - Iraq" },
  { value: "IRL", label: "IRL - Ireland" },
  { value: "IMN", label: "IMN - Isle of Man" },
  { value: "ISR", label: "ISR - Israel" },
  { value: "ITA", label: "ITA - Italy" },
  { value: "JAM", label: "JAM - Jamaica" },
  { value: "JPN", label: "JPN - Japan" },
  { value: "JEY", label: "JEY - Jersey" },
  { value: "JOR", label: "JOR - Jordan" },
  { value: "KAZ", label: "KAZ - Kazakhstan" },
  { value: "KEN", label: "KEN - Kenya" },
  { value: "KIR", label: "KIR - Kiribati" },
  { value: "PRK", label: "PRK - Korea (North)" },
  { value: "KOR", label: "KOR - Korea (South)" },
  { value: "KWT", label: "KWT - Kuwait" },
  { value: "KGZ", label: "KGZ - Kyrgyzstan" },
  { value: "LAO", label: "LAO - Laos" },
  { value: "LVA", label: "LVA - Latvia" },
  { value: "LBN", label: "LBN - Lebanon" },
  { value: "LSO", label: "LSO - Lesotho" },
  { value: "LBR", label: "LBR - Liberia" },
  { value: "LBY", label: "LBY - Libya" },
  { value: "LIE", label: "LIE - Liechtenstein" },
  { value: "LTU", label: "LTU - Lithuania" },
  { value: "LUX", label: "LUX - Luxembourg" },
  { value: "MAC", label: "MAC - Macao" },
  { value: "MDG", label: "MDG - Madagascar" },
  { value: "MWI", label: "MWI - Malawi" },
  { value: "MYS", label: "MYS - Malaysia" },
  { value: "MDV", label: "MDV - Maldives" },
  { value: "MLI", label: "MLI - Mali" },
  { value: "MLT", label: "MLT - Malta" },
  { value: "MHL", label: "MHL - Marshall Islands" },
  { value: "MTQ", label: "MTQ - Martinique" },
  { value: "MRT", label: "MRT - Mauritania" },
  { value: "MUS", label: "MUS - Mauritius" },
  { value: "MYT", label: "MYT - Mayotte" },
  { value: "MEX", label: "MEX - Mexico" },
  { value: "FSM", label: "FSM - Micronesia" },
  { value: "MDA", label: "MDA - Moldova" },
  { value: "MCO", label: "MCO - Monaco" },
  { value: "MNG", label: "MNG - Mongolia" },
  { value: "MNE", label: "MNE - Montenegro" },
  { value: "MSR", label: "MSR - Montserrat" },
  { value: "MAR", label: "MAR - Morocco" },
  { value: "MOZ", label: "MOZ - Mozambique" },
  { value: "MMR", label: "MMR - Myanmar" },
  { value: "NAM", label: "NAM - Namibia" },
  { value: "NRU", label: "NRU - Nauru" },
  { value: "NPL", label: "NPL - Nepal" },
  { value: "NLD", label: "NLD - Netherlands" },
  { value: "NCL", label: "NCL - New Caledonia" },
  { value: "NZL", label: "NZL - New Zealand" },
  { value: "NIC", label: "NIC - Nicaragua" },
  { value: "NER", label: "NER - Niger" },
  { value: "NGA", label: "NGA - Nigeria" },
  { value: "NIU", label: "NIU - Niue" },
  { value: "NFK", label: "NFK - Norfolk Island" },
  { value: "MKD", label: "MKD - North Macedonia" },
  { value: "MNP", label: "MNP - Northern Mariana Islands" },
  { value: "NOR", label: "NOR - Norway" },
  { value: "OMN", label: "OMN - Oman" },
  { value: "PAK", label: "PAK - Pakistan" },
  { value: "PLW", label: "PLW - Palau" },
  { value: "PSE", label: "PSE - Palestine" },
  { value: "PAN", label: "PAN - Panama" },
  { value: "PNG", label: "PNG - Papua New Guinea" },
  { value: "PRY", label: "PRY - Paraguay" },
  { value: "PER", label: "PER - Peru" },
  { value: "PHL", label: "PHL - Philippines" },
  { value: "PCN", label: "PCN - Pitcairn" },
  { value: "POL", label: "POL - Poland" },
  { value: "PRT", label: "PRT - Portugal" },
  { value: "PRI", label: "PRI - Puerto Rico" },
  { value: "QAT", label: "QAT - Qatar" },
  { value: "REU", label: "REU - Réunion" },
  { value: "ROU", label: "ROU - Romania" },
  { value: "RUS", label: "RUS - Russian Federation" },
  { value: "RWA", label: "RWA - Rwanda" },
  { value: "BLM", label: "BLM - Saint Barthélemy" },
  { value: "SHN", label: "SHN - Saint Helena, Ascension and Tristan da Cunha" },
  { value: "KNA", label: "KNA - Saint Kitts and Nevis" },
  { value: "LCA", label: "LCA - Saint Lucia" },
  { value: "MAF", label: "MAF - Saint Martin (French part)" },
  { value: "SPM", label: "SPM - Saint Pierre and Miquelon" },
  { value: "VCT", label: "VCT - Saint Vincent and the Grenadines" },
  { value: "WSM", label: "WSM - Samoa" },
  { value: "SMR", label: "SMR - San Marino" },
  { value: "STP", label: "STP - Sao Tome and Principe" },
  { value: "SAU", label: "SAU - Saudi Arabia" },
  { value: "SEN", label: "SEN - Senegal" },
  { value: "SRB", label: "SRB - Serbia" },
  { value: "SYC", label: "SYC - Seychelles" },
  { value: "SLE", label: "SLE - Sierra Leone" },
  { value: "SGP", label: "SGP - Singapore" },
  { value: "SXM", label: "SXM - Sint Maarten (Dutch part)" },
  { value: "SVK", label: "SVK - Slovakia" },
  { value: "SVN", label: "SVN - Slovenia" },
  { value: "SLB", label: "SLB - Solomon Islands" },
  { value: "SOM", label: "SOM - Somalia" },
  { value: "ZAF", label: "ZAF - South Africa" },
  { value: "SGS", label: "SGS - South Georgia and the South Sandwich Islands" },
  { value: "SSD", label: "SSD - South Sudan" },
  { value: "ESP", label: "ESP - Spain" },
  { value: "LKA", label: "LKA - Sri Lanka" },
  { value: "SDN", label: "SDN - Sudan" },
  { value: "SUR", label: "SUR - Suriname" },
  { value: "SJM", label: "SJM - Svalbard and Jan Mayen" },
  { value: "SWE", label: "SWE - Sweden" },
  { value: "CHE", label: "CHE - Switzerland" },
  { value: "SYR", label: "SYR - Syrian Arab Republic" },
  { value: "TWN", label: "TWN - Taiwan" },
  { value: "TJK", label: "TJK - Tajikistan" },
  { value: "TZA", label: "TZA - Tanzania" },
  { value: "THA", label: "THA - Thailand" },
  { value: "TLS", label: "TLS - Timor-Leste" },
  { value: "TGO", label: "TGO - Togo" },
  { value: "TKL", label: "TKL - Tokelau" },
  { value: "TON", label: "TON - Tonga" },
  { value: "TTO", label: "TTO - Trinidad and Tobago" },
  { value: "TUN", label: "TUN - Tunisia" },
  { value: "TUR", label: "TUR - Türkiye" },
  { value: "TKM", label: "TKM - Turkmenistan" },
  { value: "TCA", label: "TCA - Turks and Caicos Islands" },
  { value: "TUV", label: "TUV - Tuvalu" },
  { value: "UGA", label: "UGA - Uganda" },
  { value: "UKR", label: "UKR - Ukraine" },
  { value: "ARE", label: "ARE - United Arab Emirates" },
  { value: "GBR", label: "GBR - United Kingdom" },
  { value: "USA", label: "USA - United States" },
  { value: "UMI", label: "UMI - United States Minor Outlying Islands" },
  { value: "URY", label: "URY - Uruguay" },
  { value: "UZB", label: "UZB - Uzbekistan" },
  { value: "VUT", label: "VUT - Vanuatu" },
  { value: "VEN", label: "VEN - Venezuela" },
  { value: "VNM", label: "VNM - Viet Nam" },
  { value: "VGB", label: "VGB - Virgin Islands (British)" },
  { value: "VIR", label: "VIR - Virgin Islands (U.S.)" },
  { value: "WLF", label: "WLF - Wallis and Futuna" },
  { value: "ESH", label: "ESH - Western Sahara" },
  { value: "YEM", label: "YEM - Yemen" },
  { value: "ZMB", label: "ZMB - Zambia" },
  { value: "ZWE", label: "ZWE - Zimbabwe" },
];
